export default __webpack_public_path__ + "static/torii-4-3f93323365619c6c99ba0b2d20ad9a2d.jpg";